<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Dollar from "@/assets/media/svg/icons/Shopping/Dollar.svg";
import Sort3 from "@/assets/media/svg/icons/Shopping/Sort3.svg";
import UserSvg from "@/assets/media/svg/icons/General/User.svg";
import DashboardCard from "@/view/components/segmentations/DashboardCard.vue";
import HeatmapTable from "@/view/components/segmentations/HeatmapTable.vue";
import VisitFrequency from "@/view/components/segmentations/VisitFrequency.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { getSegments } from "@/api/campaigns.js";
import {
  getBenchmarkCohortDataRetentionMatrix,
  getBenchmarkCohortDataCohortSize,
  getSegmentDashboardData,
  getBenchmarkCohort
} from "@/api/dashboard.js";
import swal from "sweetalert";
import { roundOff, numberWithCommas, getDateRange } from "@/utils";
import moment from "moment";
const startOfMonth = moment()
  .subtract(1, "months")
  .startOf("month")
  .format("YYYY-MM-DD");
const endOfMonth = moment()
  .subtract(1, "months")
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "segments-dashboard",
  components: {
    DashboardCard,
    HeatmapTable,
    VisitFrequency,
    VueCtkDateTimePicker
  },
  data() {
    return {
      items: [],
      locations: [],
      loading: true,
      loadingData: true,
      cohort_data: null,
      dashboard_data: null,
      segment: null,
      fullWidth: false,
      avatar: "https://cdn.vuetifyjs.com/images/cards/halcyon.png",
      color: "#1e1e2d",
      dtpicker: { start: `${startOfMonth}`, end: `${endOfMonth}` },
      maxDate: moment().format("YYYY-MM-DD"),
      location_id: null,
      subscribers_total: 0,
      guest_total: 0,
      average_frequency: 0,
      average_check: 0,
      average_recency: 0,
      lifetime_revenue: 0,
      business_revenue: 0,
      loadingCohort: true,
      searching: true,
      guests_visits: [],
      loading_guests_visits: true,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      snackbar: false,
      text: "",
      vertical: true,
      show_heatmap: false,
      show_visit_frequency: false,
      view: "all",
      viewOptions: [
        { text: "All Customers", value: "all" },
        { text: "Marketable Customers", value: "subscriber" },
        { text: "Trackable Customers", value: "guest" }
      ],
      searchTerm: null,
      segmentsCopy: [],
      segmentsOptions: [],
      rangeTypeOptions: [
        { text: "Last 60 days", value: 60 },
        { text: "Last 90 days", value: 90 },
        { text: "Last 6 months (today - 182 days)", value: 182 },
        { text: "Last year (today - 365 days)", value: 365 }
      ],
      range_type: 60
    };
  },
  async beforeMount() {
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Segments Dashboard" }]);
    this.$store.commit("setLocationVisibile", false);
    var accountSetting = await this.$store.getters["getAccountSettings"];
    if (!accountSetting.length){
      await this.$store.dispatch("getAccountSettings");
      accountSetting = await this.$store.getters["getAccountSettings"];
    }
    let aggregatedDate = accountSetting.company_details.company['aggregated_date']
    this.maxDate = moment(aggregatedDate).format("YYYY-MM-DD")
    let last365 = moment(this.maxDate).subtract(1, 'years')
    last365 = last365.format("YYYY-MM-DD");

    this.dtpicker.start = last365
    this.dtpicker.end = this.maxDate

    const response = await getSegments();
    if (!response) {
      swal("", "Something went wrong in fetching data. Please try again later");
    }
    this.items = response;
    // console.log("this.items", this.items);
    setTimeout(() => {
      if (this.items.length == 0) {
        swal("No segments detected", "Please create atleast one.").then(() => {
          this.$router.push(`/segments`);
        });
        return;
      }
      let index = this.getIndex(this.items);
      let segment = this.items[index];
      // this.segment = segment.id;
      let segment_id = segment && segment.id ? segment.id : null;
      window.sessionStorage.setItem("segment_id", segment_id);
      this.setSegments();
    }, 600);

    this.show_heatmap = false;
    this.show_visit_frequency = false;
    setTimeout(() => {
      let elems = document.getElementsByClassName("multiselect__content");
      if (elems[0]) {
        elems[0].style.paddingLeft = "0px";
      }
      if (elems[1]) {
        elems[1].style.paddingLeft = "0px";
      }
      // this.onSearch();
      this.searching = false;
      this.loading = false;
      this.loadingData = false;
      this.loadingCohort = false;
    }, 1000);
  },
  computed: {
    dashboardData() {
      return this.$store.getters["getSegmentDashboardData"];
    },
    dollarSvg() {
      return Dollar;
    },
    daysSvg() {
      return Sort3;
    },
    userSvg() {
      return UserSvg;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    dashboardData(newVal) {
      this.dashboard_data = newVal;
      this.subscribers_total =
        this.dashboard_data && this.dashboard_data.subscribers
          ? numberWithCommas(this.dashboard_data.subscribers)
          : 0;
      this.guest_total =
        this.dashboard_data && this.dashboard_data.guests
          ? numberWithCommas(this.dashboard_data.guests)
          : 0;
      this.average_frequency =
        this.dashboard_data && this.dashboard_data.average_frequency
          ? roundOff(parseFloat(this.dashboard_data.average_frequency)) + " visits"
          : 0;
      this.average_check =
        this.dashboard_data && this.dashboard_data.average_check
          ? "$" + roundOff(parseFloat(this.dashboard_data.average_check))
          : 0;
      this.average_recency =
        this.dashboard_data && this.dashboard_data.average_recency
          ? parseInt(this.dashboard_data.average_recency) + " days"
          : 0;
      this.lifetime_revenue =
        this.dashboard_data && this.dashboard_data.lifetime_revenue
          ? "$" + roundOff(parseFloat(this.dashboard_data.lifetime_revenue))
          : 0;
      this.business_revenue =
        this.dashboard_data && this.dashboard_data.business_revenue
          ? "$" + roundOff(parseFloat(this.dashboard_data.business_revenue))
          : 0;
      this.guests_visits =
        this.dashboard_data && this.dashboard_data.guests_visits
          ? this.dashboard_data.guests_visits
          : [];
      this.loading_guests_visits = false;
    }
  },
  methods: {
    setSegments() {
      this.segmentsOptions = [
        ...this.items.map(item => {
          return {
            value: item.id,
            text: `${item.name}`
          };
        })
      ];
      this.segmentsCopy = [...this.segmentsOptions];
    },
    filterLocations() {
      if (!this.searchTerm || this.segmentsOptions.length == 0) {
        this.segmentsOptions = this.segmentsCopy;
      }
      this.segmentsOptions = this.segmentsOptions.filter(item => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
      this.searchTerm = null
      this.filterLocations()
    },
    getIndex(obj) {
      return Math.floor(Math.random() * obj.length);
    },
    onSearch() {
      this.searching = true;
      this.loading = true;
      this.loadingData = true;
      this.loadingCohort = true;
      this.show_heatmap = false;
      this.show_visit_frequency = false;

      // TODO: Remove
      console.log("this.segment", this.segment);
      if (!this.segment) {
        swal("Error", "Please choose a segment");
        // this.snackbar = true;
        // this.text = "Please choose a segment";
        this.searching = false;
        this.loading = false;
        this.loadingData = false;
        this.loadingCohort = false;
        return;
      }

      let segment_id = this.segment ? this.segment : null;
      window.sessionStorage.setItem("segment_id", segment_id);
      // console.log("segment_id", segment_id);
      const payload = JSON.parse(
        JSON.stringify({
          segment_id: segment_id,
          // range_type: this.range_type,
          options: this.view,
          start_date: this.dtpicker.start,
          end_date: this.dtpicker.end
        })
      );
      const promises = Promise.all([
        getBenchmarkCohort(payload)
      ]);
      promises
        .then(results => {
          this.cohort_data = {
            retention_matrix: results[0].retention_matrix,
            cohort_size: results[0].cohort_size
          };
          this.loading = false;
          this.loadingCohort = false;
          this.searching = false;
          this.show_heatmap = true;
          this.show_visit_frequency = true;
          this.loadingData = false;
          this.$store.commit("setSegmentDashboardData", results[0].dashboard);
        })
        .catch(e => {
          this.snackbar = true;
          this.text = "There's a problem in fetching segment dashboard data";
          this.loading = false;
          this.loadingCohort = false;
          this.searching = false;
          this.show_heatmap = false;
          this.show_visit_frequency = false;
          this.loadingData = false;
        });
    }
  }
};
</script>

<style scoped>
.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  font-size: 2rem;
}

.selectdiv:after {
  /* content: '\f078';
  font: normal normal normal 17px/1 FontAwesome; */
  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/18x18/br_down.png)
    no-repeat right #ddd;
  -webkit-appearance: none;
  background-position-x: 244px;
  color: #0ebeff;
  right: 11px;
  top: 8px;
  padding: 15px 0px 0px 8px;
  position: absolute;
  pointer-events: none;
}

/* IE11 hide native button (thanks Matt!) */
select::-ms-expand {
  display: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */
  display: block;
  float: right;
  padding: 0px 10px;
  background-color: transparent;
  -ms-word-break: normal;
  word-break: normal;
}

.cards-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  width: 300px;
}

.card-icon {
  display: block;
  font-size: 40px;
  float: left;
  margin-right: 20px;
  margin-bottom: 10px;
}

.segment-select {
  cursor: pointer;
  background-color: #fff;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  position: relative;
  width: 100%;
  height: 42px;
  min-height: 42px;
  padding-left: 12px;
  padding-right: 44px;
  font-weight: 400;
  -webkit-appearance: none;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  font-size: 14px;
  z-index: 0;
}

.subheader {
  /* background: #ffffff !important; */
  background: #e9eaf3 !important;
  /* height: 70px !important; */
}
.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}
.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}

.content-box {
  margin-top: 40px;
}
@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}

.option__title {
  font-size: 14px;
}
.option__small {
  font-size: 10px;
}

.v-text-field--outlined >>> fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <div class="subheader d-flex align-items-center justify-content-center">
        <div class="mr-2" style="width: 250px;">
          <VueCtkDateTimePicker
            v-model="dtpicker"
            :max-date="maxDate"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select date range"
            range
          />
          <!-- <v-select
            v-model="range_type"
            :items="rangeTypeOptions"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
          >
          </v-select> -->
        </div>
        <div class="mr-2 mt-6" style="width: 250px;">
          <v-select
            v-model="view"
            :items="viewOptions"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
          >
          </v-select>
        </div>
        <div class="mr-2 mt-6" style="width: 250px;">
          <v-select
            v-model="segment"
            :items="segmentsOptions"
            placeholder="Select Segment"
            label="Segment"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchTerm"
                    placeholder="Search"
                    @input="filterLocations"
                    @blur="filterLocationsBlur"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
        </div>
        <div>
          <v-btn
            md
            depressed
            color="primary"
            style="height:40px;"
            @click="onSearch()"
            :loading="loading"
            :disabled="searching"
          >
            <v-icon> mdi-magnify {{ loading }}</v-icon>
          </v-btn>
        </div>
      </div>
      <!-- Cards -->
      <b-row class="content-box" align-v="stretch">
        <b-col sm>
          <b-row class="mt-n3">
            <b-col v-if="view === 'subscriber' || view === 'all'">
              <dashboard-card
                title="Marketable Customers"
                :value="subscribers_total"
                :img="userSvg"
                :loading="loadingData"
              ></dashboard-card>
            </b-col>
            <b-col v-if="view === 'guest' || view === 'all'">
              <dashboard-card
                title="Trackable Customers"
                :value="guest_total"
                :img="userSvg"
                :loading="loadingData"
              ></dashboard-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm>
          <dashboard-card
            title="Average Visit Frequency"
            :value="average_frequency"
            :img="daysSvg"
            :loading="loadingData"
          ></dashboard-card>
        </b-col>
        <b-col sm>
          <dashboard-card
            title="Average Check"
            :value="average_check"
            :img="dollarSvg"
            :loading="loadingData"
          ></dashboard-card>
        </b-col>
      </b-row>
      <b-row align-v="stretch">
        <b-col sm>
          <dashboard-card
            title="Average Recency"
            :value="average_recency"
            :img="daysSvg"
            :loading="loadingData"
          ></dashboard-card>
        </b-col>
        <b-col sm>
          <dashboard-card
            title="Average Lifetime Value"
            :value="lifetime_revenue"
            :img="dollarSvg"
            :loading="loadingData"
          ></dashboard-card>
        </b-col>
        <b-col sm>
          <dashboard-card
            title="Business Revenue"
            :value="business_revenue"
            :img="dollarSvg"
            :loading="loadingData"
          ></dashboard-card>
        </b-col>
      </b-row>
      <!-- End Cards -->

      <!-- Guest Retention -->
      <v-row>
        <v-col cols="12" sm="12">
          <v-card elevation="2" :loading="loadingCohort">
            <v-card-title>Customer Retention</v-card-title>
            <v-card-subtitle>
              On Average, customers on this segment return to your restaurant every
              <strong>{{ average_recency }}.</strong>
            </v-card-subtitle>
            <v-row>
              <v-col cols="12" sm="12" class="ml-2 mr-2">
                <heatmap-table
                  v-if="show_heatmap"
                  :cohort_data="cohort_data"
                  :dtpicker="dtpicker"
                ></heatmap-table>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12">
          <v-card elevation="2" :loading="loadingCohort">
            <visit-frequency
              v-if="show_visit_frequency"
              :items="guests_visits"
            ></visit-frequency>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar"
        :vertical="vertical"
        content-class="background:red"
        color="danger"
        dark
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>
